<template>
  <div class="page1 page move">
    <div class="border bl1">
        <div class="guoduye">
            <img src="../assets/img/huamian.png" alt="" class="huamian">
            <img src="../assets/img/sufx.png" alt="" class="sjfx">

            <div class="guoduye1 gy"><span></span><span></span><span></span></div>
            <div class="guoduye2 gy"><span></span><span></span><span></span></div>
            <div class="guoduye3 gy"><span></span><span></span><span></span></div>
            <div class="guoduye4 gy"><span></span><span></span><span></span></div>
            <div class="guoduye5 gy"><span></span><span></span><span></span></div>
        </div>
    </div>
    <div class="border bl2">
      <div class="page-center">

      


        <canvas id="p1_bg" class="pagea"></canvas>

        <div class="shipei">
          <div class="tmxz1 pbox">
          <div class="p1-1-box pbox">
            <canvas id="p1_1_canvas" class="pagea"></canvas>
            <!-- <div class="p1-1-3">
              <div class="ani"  @click="nextAnswer"></div>
            </div> -->
          </div>

         

          <div class="p1-2-box pbox">
            <canvas id="p1_2_canvas" class="pagea"></canvas>
            <!-- <div class="p1-2-3">
              <div class="ani"  @click="nextAnswer"></div>
            </div> -->
          </div>

          <div class="p1-3-box pbox">
            <canvas id="p1_3_canvas" class="pagea"></canvas>
            <!-- <div class="p1-3-3">
              <div class="ani"  @click="nextAnswer"></div>
            </div> -->
          </div>

          <div class="p1-4-box pbox">
            <canvas id="p1_4_canvas" class="pagea"></canvas>
            <!-- <div class="p1-4-3">
              <div class="ani"  @click="nextAnswer"></div>
            </div> -->
          </div>

           <div class="p1-1-1">
            <div class="ani"></div>
          </div>
          <div class="p1-1-2">
            <div class="ani"></div>
          </div>

          <div class="option p1-option">
              <div :class="['p1-optiom-1','optiom',opsIdx[0] == 0 ? 'cur' :''] " @click="x_nextOption(0,0)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-2','optiom',opsIdx[0] == 1 ? 'cur' :''] " @click="x_nextOption(0,1)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-3','optiom',opsIdx[0] == 2 ? 'cur' :''] " @click="x_nextOption(0,2)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-4','optiom',opsIdx[0] == 3 ? 'cur' :''] " @click="x_nextOption(0,3)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
          </div>
        </div>

         <div class="tmxz2 pbox">
          <div class="p2-1-box pbox">
            <canvas id="p2_1_canvas" class="pagea"></canvas>
          </div>

          <div class="p2-2-box pbox">
            <canvas id="p2_2_canvas" class="pagea"></canvas>
          </div>
          <div class="p2-3-box pbox">
            <canvas id="p2_3_canvas" class="pagea"></canvas>
          </div>
          <div class="p2-4-box pbox">
            <canvas id="p2_4_canvas" class="pagea"></canvas>
          </div>

           <div class="p2-1-1">
              <div class="ani"></div>
            </div>
            <div class="p2-1-2">
              <div class="ani"></div>
            </div>

            <div class="option p2-option">
              <div :class="['p1-optiom-1','optiom',opsIdx[1] == 0 ? 'cur' :''] " @click="x_nextOption(1,0)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-2','optiom',opsIdx[1] == 1 ? 'cur' :''] " @click="x_nextOption(1,1)">

                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-3','optiom',opsIdx[1] == 2 ? 'cur' :''] " @click="x_nextOption(1,2)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-4','optiom',opsIdx[1] == 3 ? 'cur' :''] " @click="x_nextOption(1,3)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
          </div>
        </div> 

        <div class="tmxz3 pbox">
          <div class="p3-1-box pbox">
            <canvas id="p3_1_canvas" class="pagea"></canvas>
          </div>

          <div class="p3-2-box pbox">
            <canvas id="p3_2_canvas" class="pagea"></canvas>
          </div>

          <div class="p3-3-box pbox">
            <canvas id="p3_3_canvas" class="pagea"></canvas>
          </div>

          <div class="p3-4-box pbox">
            <canvas id="p3_4_canvas" class="pagea"></canvas>
          </div>
            <div class="p3-1-1">
              <div class="ani"></div>
            </div>
            <div class="p3-1-2">
              <div class="ani"></div>
            </div>

               <div class="option p3-option">
              <div :class="['p1-optiom-1','optiom',opsIdx[2] == 0 ? 'cur' :''] " @click="x_nextOption(2,0)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-2','optiom',opsIdx[2] == 1 ? 'cur' :''] " @click="x_nextOption(2,1)">

                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-3','optiom',opsIdx[2] == 2 ? 'cur' :''] " @click="x_nextOption(2,2)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-4','optiom',opsIdx[2] == 3 ? 'cur' :''] " @click="x_nextOption(2,3)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
          </div>
        </div>

        <div class="tmxz4 pbox">
          <div class="p4-1-box pbox">
            <canvas id="p4_1_canvas" class="pagea"></canvas>
          </div>

          <div class="p4-2-box pbox">
            <canvas id="p4_2_canvas" class="pagea"></canvas>
          </div>

          <div class="p4-3-box pbox">
            <canvas id="p4_3_canvas" class="pagea"></canvas>
          </div>

          <div class="p4-4-box pbox">
            <canvas id="p4_4_canvas" class="pagea"></canvas>
          </div>
           <div class="p4-1-1">
              <div class="ani"></div>
            </div>
            <div class="p4-1-2">
              <div class="ani"></div>
            </div>

            <div class="option p4-option">
              <div :class="['p1-optiom-1','optiom',opsIdx[3] == 0 ? 'cur' :''] " @click="x_nextOption(3,0)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-2','optiom',opsIdx[3] == 1 ? 'cur' :''] " @click="x_nextOption(3,1)">

                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-3','optiom',opsIdx[3] == 2 ? 'cur' :''] " @click="x_nextOption(3,2)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-4','optiom',opsIdx[3] == 3 ? 'cur' :''] " @click="x_nextOption(3,3)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
          </div>

        </div>

        <div class="tmxz5 pbox">
          <div class="p5-1-box pbox">
            <canvas id="p5_1_canvas" class="pagea"></canvas>
          </div>

          <div class="p5-2-box pbox">
            <canvas id="p5_2_canvas" class="pagea"></canvas>
          </div>

          <div class="p5-3-box pbox">
            <canvas id="p5_3_canvas" class="pagea"></canvas>
          </div>

          <div class="p5-4-box pbox">
            <canvas id="p5_4_canvas" class="pagea"></canvas>
          </div>
           <div class="p5-1-1">
              <div class="ani"></div>
            </div>
            <div class="p5-1-2">
              <div class="ani"></div>
            </div>
              <div class="option p5-option" >
              <div :class="['p1-optiom-1','optiom',opsIdx[4] == 0 ? 'cur' :''] " @click="x_nextOption(4,0)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-2','optiom',opsIdx[4] == 1 ? 'cur' :''] " @click="x_nextOption(4,1)">

                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-3','optiom',opsIdx[4] == 2 ? 'cur' :''] " @click="x_nextOption(4,2)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
              <div :class="['p1-optiom-4','optiom',opsIdx[4] == 3 ? 'cur' :''] " @click="x_nextOption(4,3)">
                <div class="yuanq"></div>
                <div class="a1"></div>
                <div class="a2"></div>
              </div>
          </div>
        </div>
        <div class="ann_btn">
          <canvas id="btn" @click="nextAnswer"></canvas>
        </div>
        </div>
      </div>


      <img src="../assets/img/sw1.png" alt="" v-if="index == 0" class="timu" />
      <img
        src="../assets/img/sw2.png"
        alt=""
        v-else-if="index == 1"
        class="timu"
      />
      <img
        src="../assets/img/sw3.png"
        alt=""
        v-else-if="index == 2"
        class="timu"
      />
      <img
        src="../assets/img/sw4.png"
        alt=""
        v-else-if="index == 3"
        class="timu"
      />
      <img
        src="../assets/img/sw5.png"
        alt=""
        v-else-if="index == 4"
        class="timu"
      />
      <img src="../assets/img/sw6.png" alt="" v-else class="timu" />
    </div>
      
      <div class="returnprve" @click="prveAnswer">
        <img src="../assets/img/p2back.png" alt="" class="">
      </div>
  </div>
</template>
<script>
export default {
  props: ["index", "opsIdx","idx"],
  components: {},
  data() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },

  mounted: async function () {},
  methods: {
    x_nextOption(a,b){
        this.$parent.x_nextOption(a,b);
    },
    nextOption() {
      this.$parent.nextOption();
    },
    prveOption() {
      this.$parent.prveOption();
    },
    nextAnswer() {
      this.$parent.nextAnswer();
    },
    prveAnswer(){
      this.$parent.prveAnswer();
    }
  },
};
</script>

<style lang="less">
@vw: 7.5vw;
canvas {
  width: 100%;
}

.page1 {
  opacity: 0;
  visibility: hidden;
}
</style>
